import { StateCreator } from "zustand";

export interface SignInPopUpSlice {
  signInPopup: boolean;
  setSignInPopup: (signInPopup: boolean) => void;
}

const createSignInPopUpSlice: StateCreator<
  SignInPopUpSlice,
  [],
  [],
  SignInPopUpSlice
> = (set) => ({
  signInPopup: false,
  setSignInPopup: (signInPopup: boolean) => set({ signInPopup }),
});

export default createSignInPopUpSlice;
